import { Rect } from "../Types";

export const MAGIC_LAYOUT_ID = "omakase";
export const MAGIC_LAYOUT_NAME = "omakase 🍣";
export const HIDDEN_PANE_RECT: Rect = [0, 0, 0, 0];

export const RENDER_RUN_BUTTON_WIDTH = 64;
export const RENDER_RUN_BUTTON_HEIGHT = 32;
export const PANE_HEADER_BAR_HEIGHT = 32;

export const PANE_ERROR_STACK_PREFIX = "_P4N3_";
export const CANVAS_PORTAL_ID = "canvas-portal";
